<template>
  <div class="chatBox main-container">
    <Button class="read-btn" type="primary" @click="readAll">一键已读</Button>
    <Button @click="$router.go(-1)" class="back-btn">返回</Button>
    <Tabs v-model="type" :animated="false" @on-click="toggleFirstTab">
      <div v-for="(item, index) in tabNumList" :key="index">
        <TabPane :label="item.tabName" :name="item.tabCode" v-if="item.secondTab !=5"></TabPane>
      </div>
    </Tabs>
    <Tabs v-if="secondTabList.length" v-model="secondTab" class="second-tabs" @on-click="toggleSecondTab">
      <TabPane :label="item.tabName" :name="item.tabCode" v-for="(item, index) in secondTabList" :key="index"></TabPane>
    </Tabs>
    <ul v-loading="loading" v-if="list && list.length > 0">
      <li class="clearfix" v-for="(item, index) in list" :key="index" :class="{ hasRead: item.hasReaded }"
        @click="jumpDetail(item)">
        <span>{{ item.title }}</span>
        <span>{{ item.sendTime | filterTime('YYYY-MM-DD HH:mm') }}</span>
      </li>
    </ul>

    <no-data v-else></no-data>

    <Page :total="total" :current.sync="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
      style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { chatMangeList, lookChatReadNum } from "@/api/httpList";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      list: [],
      secondTabList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      type: "1",
      secondTab: "",
      tabNumList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    readAll() {
      this.$notice.inquiry('确认将消息全部标记为已读').then(async () => {
        this.$http({
          type: "get",
          url: "/buz/noticeConfig/read/allMsg",
          data: {
            tabCode: this.type,// 1.全部公告 2.商品公告 3.系统通知
          }
        }).then(() => {
          this.getChatList();
          this.getNum();
          this.postMessage();
        })
      })
    },
    // 更新父级页面消息数量
    postMessage() {
      window.parent.postMessage({
        reloadReadNum: true,
        appMessage: true,
      }, "*");
    },
    // 跳转详情页
    jumpDetail(item) {
      // 打开详情页
      window.open('/home/detail?id=' + item.id);
      // 修改读取状态
      this.$http({
        type: "get",
        url: "/buz/noticeConfig/read/msg",
        data: {
          id: item.id
        }
      }).then(() => {
        this.getNum()
        this.getChatList();
        window.parent.postMessage({
          reloadReadNum: true,
          appMessage: true,
        }, "*");
      })
    },
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getChatList();
    },
    toggleFirstTab() {
      // if (this.type != "1") {
      //   toggleFirstTab(this.type);
      // }
      this.pageNo = 1;
      this.getNum(this.type);
      if (this.type == 2) {
        this.secondTab = "1";
      } else {
        this.secondTab = "";
      }
      this.getChatList();
    },
    toggleSecondTab() {
      this.pageNo = 1;
      this.getChatList();
    },

    getChatList() {
      this.loading = true;
      chatMangeList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        firstTab: this.type,
        secondTab: this.secondTab
      }).then(res => {
        this.loading = false;
        this.total = res.total;
        this.list = res.data;
      }).catch(err => {
        this.loading = false;
      });
    },
    getNum() {
      this.secondTabList = [];

      lookChatReadNum(1).then(res => {
        const arr = ["全部公告", "商品公告", "系统通知"];
        this.tabNumList = res.data.map((item, index) => ({
          ...item,
          tabName:
            arr[index] +
            "(" +
            (+item.count > 99 ? "99+" : item.count) +
            "未读)"
        }));
      });
      if (this.type == 2) {
        //获取二级tab
        lookChatReadNum(this.type).then(res => {
          this.secondTabList = res.data.map(item => ({
            ...item,
            tabName:
              item.tabName +
              "(" +
              (+item.count > 99 ? "99+" : item.count) +
              "未读)"
          }));
        });
      } else if (this.type == 3) {
        //获取二级tab
        lookChatReadNum(this.type).then(res => {
          const arr = ["系统公告", "活动通知", "直播通知"];
          this.secondTabList = res.data.map((item, index) => ({
            ...item,
            tabName:
              arr[index] +
              "(" +
              (+item.count > 99 ? "99+" : item.count) +
              "未读)"
          }));
        });
      }
    }
  },
  created() { },
  mounted() {
    this.getChatList();
    this.getNum();
  }
};
</script>
<style lang="scss" scoped>
.chatBox {
  position: relative;

  .read-btn {
    position: absolute;
    right: 115px;
    z-index: 2;
  }

  .back-btn {
    position: absolute;
    right: 40px;
    z-index: 2;
  }

  .noDate {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 60px;
  }

  padding: 20px;

  /deep/ .secondTab {
    .ivu-tabs-tab {
      font-size: 15px;
    }

    .ivu-tabs-bar {
      border-bottom: none !important;
    }

    .ivu-tabs-ink-bar {
      height: 0 !important;
    }
  }

  ul {
    padding: 20px;
    padding-top: 0;

    li {
      &:first-child {
        border-top: 0;
      }

      span {
        font-size: 14px;
      }

      &.hasRead {
        color: #aaa;
      }

      &:hover {
        cursor: pointer;
      }

      padding: 15px 0;
      border-bottom: 1px dashed #ddd;
      font-size: 16px;
      color: #333;

      span:nth-child(1) {
        float: left;
      }

      span:nth-child(2) {
        float: right;
        color: #8a9095;
      }
    }
  }
}
</style>
